module.exports = __webpack_public_path__ + "img/logo_vertical.a51e801e.svg";